<template>
  <div class="space-y-[1px] overflow-hidden rounded-lg">
    <div class="p-2.5 min-h-10 flex items-center bg-white dark:bg-dark-800 space-x-2 cursor-pointer hover:bg-urchin-100 hover:text-urchin-950 transition" v-for="suggestion in suggestions" @click.stop.prevent="() => emit('select', suggestion)">
      <template v-if="suggestion.type === 'mention'">
        <UserPicture :user="suggestion.user ?? null" size="sm+" class="shrink-0" />

        <div class="grow  leading-none space-y-1">
          <p class="line-clamp-1 font-bold break-all ">{{ suggestion.user?.name }}</p>
          <p class="line-clamp-1 font-medium break-all text-sm opacity-50">@{{ suggestion.user?.username }}</p>
        </div>
      </template>
    </div>

    <div v-if="isLoading && suggestions.length <= 0" class="min-h-10 flex items-center text-charcoal-300 justify-center">
      <IconBase name="cute/spinner" class="spin" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { User } from '@/classes'
import UsersStore from '@/store/users'

export type Suggestion = {
  type: 'mention'
  id: string
  label: string
  user?: User | null
}

const props = defineProps<{
  suggestions: Suggestion[]
  isLoading: boolean
}>()

const emit = defineEmits<{
  (e: 'select', suggestion: Suggestion): void
}>()

const usersStore = UsersStore()

const suggestions = computed(() => props.suggestions.map(s => {
  if (s.type === 'mention') {
    return {
      ...s,
      user: usersStore.getItem(s.id)
    }
  }

  return s
}))

</script>